import { render } from "./ChatDrawer.vue?vue&type=template&id=18830ded"
import script from "./ChatDrawer.vue?vue&type=script&lang=js"
export * from "./ChatDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__